var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2520,
    height: 1700,
    viewBox: "0 0 2520 1700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M1509 596V604.5L1687.5 606V688.5H1763.5V785.216H1940.66V1401H1930V1550H1935V1564L2407.5 1589.5V1361.73V430V350V288V236.814V106.5H1502V158.5V236.814H1509V249V272.098V565.137V596Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.58824
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M1177.5 665V688.922H943.725H882.127H860.5V784H526.892V977.774V1022.03V1380.5V1383.25V1400V1469V1482.5L237.5 1466V104H1146V157L1141.5 562.735V579.5H1177.5V596.824V665Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.58824
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M1109.5 784V807.5V912.627V962.265V996.353H1116.5V1361.5V1382.5V1402V1506.5H1109.5V1516L1520.24 1540V1528V1527V1482.5V996.353V961.069V784H1191.91H1109.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.58824
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M1521.5 784.5V860V860.598V911.431V913.225V961V996.353V1400.03V1400.63V1527.5V1540.5L1697.26 1548L1934 1564V1551H1929.5V1400H1939.5V1383.88V1363.55V996.353V963.461V784.5H1589.21H1521.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.58824
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M527.5 784H827.676H1052.54H1109.35V996.755H1115.33V1361.56V1382.49V1400.5V1506H1108.16L1108 1516L527.5 1482V1471V1402V1400.5V1379V784Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3.58824
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor2);
export default __webpack_public_path__ + "static/media/select-floor-2.065909cd.svg";
export { ForwardRef as ReactComponent };